<template>
  <div class="container-fluid">

    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">General Setting</h1>
    </div>
    <GeneralSettingForm></GeneralSettingForm>
  </div>

</template>

<script>


import GeneralSettingForm from "@/components/setting/GeneralSettingForm.vue";

export default {
  name: "GeneralSettingEditPage",
  components: {GeneralSettingForm}
}
</script>


<style scoped>

</style>
